@if ((horizontalLines() === 'top' || horizontalLines() === 'both') && curve() === 'none') {
  <hr class="mt-2 border-0 h-[1px] bg-[--color-secondary]" />
}
<div
  class="curved-box bg-linear bg-no-repeat bg-top relative min-h-full text-[--color-text-hero-area]"
  [ngClass]="mergedClasses()"
  [style.backgroundImage]="backgroundImage() ? 'url(' + backgroundImage() + ')' : undefined"
>
  @if (curve() === 'both' || curve() === 'bottom') {
    <lib-svg [ngClass]="bottomCurveClasses()" svg="curve-outside-bottom" />
  }

  <div class="z-10 relative transition-all duration-300 max-h-full">
    <ng-content />
  </div>

  @if (curve() === 'both' || curve() === 'top') {
    <lib-svg svg="curve-outside-top" />
  }
  @if (curve() === 'top-inside') {
    <lib-svg svg="curve-inside" />
  }
</div>
@if ((horizontalLines() === 'bottom' || horizontalLines() === 'both') && curve() === 'none') {
  <hr class="mb-2 border-0 h-[1px] bg-[--color-secondary]" />
}
